import bg_benefits_dg from '@/assets/images/membership/introduction/about/bg_benefits_dg@2x.png'
import bg_benefits_e from '@/assets/images/membership/introduction/about/bg_benefits_e@2x.png'
import bg_benefits_ecom from '@/assets/images/membership/introduction/about/bg_benefits_ecom@2x.png'
import bg_benefits_pre from '@/assets/images/membership/introduction/about/bg_benefits_pre@2x.png'
import bg_benefits_pro from '@/assets/images/membership/introduction/about/bg_benefits_pro@2x.png'
import bg_benefits_rising from '@/assets/images/membership/introduction/about/bg_benefits_rising@2x.png'
import bg_benefits_rw from '@/assets/images/membership/introduction/about/bg_benefits_rw@2x.png'
import bg_benefits_v from '@/assets/images/membership/introduction/about/bg_benefits_v@2x.png'

import bg_welcome2_dg from '@/assets/images/membership/introduction/about/bg_welcome2_dg@2x.png'
import bg_welcome2_e from '@/assets/images/membership/introduction/about/bg_welcome2_e@2x.png'
import bg_welcome2_ecom from '@/assets/images/membership/introduction/about/bg_welcome2_ec@2x.png'
import bg_welcome2_pro from '@/assets/images/membership/introduction/about/bg_welcome2_pro@2x.png'
import bg_welcome2_rising from '@/assets/images/membership/introduction/about/bg_welcome2_rising@2x.png'
import bg_welcome2_rw from '@/assets/images/membership/introduction/about/bg_welcome2_rw@2x.png'
import bg_welcome2_v from '@/assets/images/membership/introduction/about/bg_welcome2_v@2x.png'
import bg_welcome2_pre from '@/assets/images/membership/introduction/about/bg_welcome2_dg@2x.png'
import { BASE_BENEFITS_LIST_EN_NEW } from '~~/i18n/locales/modules/membership'

export const useMemberShipListNew = () => {
  interface MemberShipLink {
    name: string
  }

  interface MemberShipAbout {
    description: string
    benefitsList: Array<any>
    // benefitsNewList 用于新版本的会员介绍页面，包含更多的福利信息
    benefitsNewList?: Array<any>
  }

  interface MembershipItem {
    type: number
    vipCode: string
    title: string
    CRMMarker: string
    description: string
    displayName: string
    link: MemberShipLink
    background: string
    about: MemberShipAbout | null
    company?: any
    companyApiType?: string
    theme?: any

    subBackground?: string
    welcomeBackground?: string
  }

  const modulesEmptyArray = Array(4).fill('')

  const BENEFITS_ITEM_COUNT = {
    JCE: [2, 5, 7, 6],
    JCP: [3, 5, 5, 6],
    JCR: [3, 5, 4, 6],
    // =小联盟=
    SPECIAL: [3, 6, 5, 6],
    JCPR: [3, 6, 5, 6],
    JCDG: [3, 6, 5, 6],
    JCEC: [3, 6, 5, 6],
    JCRA: [3, 6, 5, 6],
    // ========
    JCV: [1, 5, 5, 4],
  }

  function getSpecialBenefits(
    type: string,
    options?: { bg: string; icon: string } | undefined,
  ) {
    const optKeys = _merge(
      {
        folder: type,
        bg: type.toLowerCase(),
        icon: type.toLowerCase(),
      },
      options,
    )
    return modulesEmptyArray.map((item, index) => ({
      title: `membership.SPECIAL.about.benefitsList[${index}].title`,
      description: `membership.SPECIAL.about.benefitsList[${index}].description`,
      icon: `https://resources.jctrans.com/res/era-h5/h5/img/bg_benefit_${optKeys.bg}_${index + 1}.png`,
      children: Array(BENEFITS_ITEM_COUNT.SPECIAL[index])
        .fill('')
        .map((v, i) => ({
          icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_${optKeys.icon}_${index + 1}-${i + 1}.png`,
          description: `membership.SPECIAL.about.benefitsList[${index}].children[${i}]`,
        })),
    }))
  }

  const MEMBERSHIP_LIST: MembershipItem[] = [
    {
      type: 0,
      vipCode: 'JCVF',
      CRMMarker: 'JCVF',
      link: {
        name: 'membershipJCVF',
      },
      title: 'JCtrans',
      description: 'string',
      displayName: 'string',
      background: 'string',
      about: null,
    },
    {
      type: 216, // 会员类型 keyword membership type
      vipCode: 'JC Elite', // 会员名录跳转使用的 vipCode 值
      title: 'JC Elite', // 全部会员介绍页
      CRMMarker: 'JCE', // CRM标记
      // 会员的展示描述
      description: 'membership.JCE.description', // 会员详细介绍页
      // 会员的展示名
      displayName: 'membership.JCE.title', // 会员详细介绍页
      // 会员的跳转链接 与路由中的 name 属性一致
      link: {
        name: 'membershipJCTransEliteNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_elite_0820.jpg`, // 移动端只有png
      // sub
      subBackground: bg_benefits_e,
      welcomeBackground: bg_welcome2_e,
      // about 中的文本描述
      about: {
        // 描述
        description: 'membership.JCE.about.description',
        // 优势列表
        benefitsList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCE.about.benefitsList[${index}].title`,
          description: `membership.JCE.about.benefitsList[${index}].description`,
          icon: `https://resources.jctrans.com/res/era-h5/h5/img/bg_benefit_elite_${index + 1}.png`,

          children: Array(BENEFITS_ITEM_COUNT.JCE[index])
            .fill('')
            .map((v, i) => ({
              icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_elite_${index + 1}-${i + 1}.png`,
              description: `membership.JCE.about.benefitsList[${index}].children[${i}]`,
            })),
        })),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCE.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JCE[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCE.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_elite_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCE.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_elite.png`,
      },
      companyApiType: 'JCElite',
      theme: {
        color: '#4A2D13',
        lightColor: '#FFF1D7',
        gradientStart: '#FFAE63',
        gradientEnd: '#FFDA8B',
        footer: {
          color: '#4A2D13',
          gradientStart: '#FFAE63',
          gradientEnd: '#FFDA8B',
        },
      },
    },
    {
      type: 5,
      vipCode: 'GCP', // 会员名录跳转使用的 vipCode 值
      title: 'JC Premium', // 全部会员介绍页
      CRMMarker: 'JCP', // CRM标记
      description: 'membership.JCP.description',
      displayName: 'membership.JCP.title',
      link: {
        name: 'membershipJCTransPremiumNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_pre_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_pre,
      welcomeBackground: bg_welcome2_pre,
      about: {
        description: 'membership.JCP.about.description',
        benefitsList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCP.about.benefitsList[${index}].title`,
          description: `membership.JCP.about.benefitsList[${index}].description`,
          icon: `https://resources.jctrans.com/res/era-h5/h5/img/bg_benefit_premium_${index + 1}.png`,
          children: Array(BENEFITS_ITEM_COUNT.JCP[index])
            .fill('')
            .map((v, i) => ({
              icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_premium_${index + 1}-${i + 1}.png`,
              description: `membership.JCP.about.benefitsList[${index}].children[${i}]`,
            })),
        })),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCP.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JCP[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCP.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_jcp_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCP.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      theme: {
        footer: {
          color: '#fff',
          gradientStart: '#ff990b',
          gradientEnd: '#fd7943',
        },
      },
    },
    {
      type: 176,
      vipCode: 'GRP', // 会员名录跳转使用的 vipCode 值
      title: 'JC Rising', // 全部会员介绍页
      CRMMarker: 'JCR', // CRM标记
      description: 'membership.JCR.description',
      displayName: 'membership.JCR.title',
      link: {
        name: 'membershipJCTransRisingNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_rising_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_rising,
      welcomeBackground: bg_welcome2_rising,
      about: {
        description: 'membership.JCR.about.description',
        benefitsList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCR.about.benefitsList[${index}].title`,
          description: `membership.JCR.about.benefitsList[${index}].description`,
          icon: `https://resources.jctrans.com/res/era-h5/h5/img/bg_benefit_rising_${index + 1}.png`,
          children: Array(BENEFITS_ITEM_COUNT.JCR[index])
            .fill('')
            .map((v, i) => ({
              icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_rising_${index + 1}-${i + 1}.png`,
              description: `membership.JCR.about.benefitsList[${index}].children[${i}]`,
            })),
        })),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCR.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JCR[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCR.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_rising_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCR.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_rising.png`,
      },
      companyApiType: 'JCRising',
      theme: {
        color: '#396F09',
        lightColor: '#EEF6DC',
        gradientStart: '#CCE98D',
        gradientEnd: '#9ADA5B',
        footer: {
          color: '#396F09',
          gradientStart: '#CCE98D',
          gradientEnd: '#9ADA5B',
        },
      },
    },
    {
      type: 186,
      vipCode: 'JC Projects', // 会员名录跳转使用的 vipCode 值
      title: 'JC Projects', // 全部会员介绍页
      CRMMarker: 'JCPJ', // CRM标记
      description: 'membership.SPECIAL.description',
      displayName: 'membership.JCPR.title',
      link: {
        name: 'membershipJCTransProjectsAboutNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_pro_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_pro,
      welcomeBackground: bg_welcome2_pro,
      about: {
        description: 'membership.JCPR.about.description',
        benefitsList: getSpecialBenefits('Project'),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCPR.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCPR.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_pro_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCPR.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_project.png`,
      },
      companyApiType: 'JCeProjects',
      theme: {
        color: '#003BB9',
        lightColor: '#EAF1FF',
        gradientStart: '#0750EA',
        gradientEnd: '#0043D0',
        footer: {
          color: '#003BB9',
        },
      },
    },
    {
      type: 187,
      vipCode: 'JC Dangerous Goods', // 会员名录跳转使用的 vipCode 值
      title: 'JC Dangerous Goods', // 全部会员介绍页
      CRMMarker: 'JCDG', // CRM标记
      description: 'membership.SPECIAL.description',
      displayName: 'membership.JCDG.title',
      link: {
        name: 'membershipJCTransDangerousGoodsAboutNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_dg_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_dg,
      welcomeBackground: bg_welcome2_dg,
      about: {
        description: 'membership.JCDG.about.description',
        benefitsList: getSpecialBenefits('DangerousGoods', {
          bg: 'dg',
          icon: 'dg',
        }),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCDG.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCDG.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_dg_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCDG.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_dg.png`,
      },
      companyApiType: 'JCDangerousGoods',
      theme: {
        color: '#D80E0E',
        lightColor: '#FFEFEF',
        gradientStart: '#FF2525',
        gradientEnd: '#F5001D',
        footer: {
          color: '#D80E0E',
        },
      },
    },
    {
      type: 188,
      vipCode: 'JC eCommerce', // 会员名录跳转使用的 vipCode 值
      title: 'JC eCommerce', // 全部会员介绍页
      CRMMarker: 'JCEC', // CRM标记
      description: 'membership.SPECIAL.description',
      displayName: 'membership.JCEC.title',
      link: {
        name: 'membershipJCTransECommerceAboutNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_ec_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_ecom,
      welcomeBackground: bg_welcome2_ecom,
      about: {
        description: 'membership.JCEC.about.description',
        benefitsList: getSpecialBenefits('ECommerce', {
          bg: 'ecom',
          icon: 'ec',
        }),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCEC.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCEC.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_ec_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCEC.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_ecom.png`,
      },
      companyApiType: 'JCeCommerce',
      theme: {
        color: '#3C35C4',
        lightColor: '#F4EDFF',
        gradientStart: '#E0C9FF',
        gradientEnd: '#ABDCFF',
        footer: {
          color: '#3C35C4',
          gradientStart: '#E9DDFF',
          gradientEnd: '#CEEBFF',
        },
      },
    },
    {
      type: 189,
      vipCode: 'JC Railway', // 会员名录跳转使用的 vipCode 值
      title: 'JC Railway', // 全部会员介绍页
      CRMMarker: 'JCRW', // CRM标记
      description: 'membership.SPECIAL.description',
      displayName: 'membership.JCRA.title',
      link: {
        name: 'membershipJCTransRailwayAboutNew',
      },
      // 展示背景
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_rw_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_rw,
      welcomeBackground: bg_welcome2_rw,
      about: {
        description: 'membership.JCRA.about.description',
        benefitsList: getSpecialBenefits('Railway'),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCRA.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JC_SPECIAL[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCRA.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_rw_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCRA.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_railway.png`,
      },
      companyApiType: 'JCRailway',
      theme: {
        color: '#825034',
        lightColor: '#F4EFED',
        gradientStart: '#825034',
        gradientEnd: '#A47255',
        footer: {
          color: '#825034',
        },
      },
    },
    {
      type: 8, // JC Vendor 会员类型
      vipCode: 'JC Vendor', // 会员名录跳转使用的 vipCode 值
      title: 'JC Vendor', // 全部会员介绍页
      CRMMarker: 'JCV', // CRM标记
      description: 'membership.JCV.description',
      displayName: 'membership.JCV.title',
      link: {
        name: 'membershipJCTransVendorNew',
      },
      background: `https://resources.jctrans.com/res/era-h5/h5/img/banner_v_0820.jpg`, // 移动端只有png
      subBackground: bg_benefits_v,
      welcomeBackground: bg_welcome2_v,
      about: {
        description: 'membership.JCV.about.description',
        benefitsList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCV.about.benefitsList[${index}].title`,
          description: `membership.JCV.about.benefitsList[${index}].description`,
          icon: `https://resources.jctrans.com/res/era-h5/h5/img/bg_benefit_vendor_${index + 1}.png`,
          children: Array(BENEFITS_ITEM_COUNT.JCV[index])
            .fill('')
            .map((v, i) => ({
              icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_vendor_${index + 1}-${i + 1}.png`,
              description: `membership.JCV.about.benefitsList[${index}].children[${i}]`,
            })),
        })),
        benefitsNewList: modulesEmptyArray.map((item, index) => ({
          title: `membership.JCV.about.benefitsListNew[${index}].title`,
          children: BASE_BENEFITS_LIST_EN_NEW.JCV[index]?.children.map(
            (v, i) => ({
              subTitle: `membership.JCV.about.benefitsListNew[${index}].children[${i}].subTitle`,
              children: v.children.map((child, j) => ({
                icon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_benefit_vendor_${index + 1}-${i + 1}-${j + 1}.png`,
                description: `membership.JCV.about.benefitsListNew[${index}].children[${i}].children[${j}]`,
              })),
            }),
          ),
        })),
      },
      // 公司介绍
      company: {
        moreIcon: `https://resources.jctrans.com/res/era-h5/h5/img/icon_arrow_vendor.png`,
      },
      companyApiType: 'JCVendor',
      theme: {
        color: '#366C62',
        lightColor: '#E4F0E7',
        gradientStart: '#476C36',
        gradientEnd: '#366C62',
        footer: {
          color: '#366C62',
        },
      },
    },
  ]

  function getCurrent(name: string) {
    return (
      <MembershipItem>MEMBERSHIP_LIST.find((item) => item.link.name === name) ||
      {}
    )
  }

  const rAF = window?.requestAnimationFrame || ((func) => setTimeout(func, 16))

  const scrollToBottom = (
    target: { scrollTop: number },
    endValue: number,
    callback: () => any,
  ) => {
    const beginTime = Date.now()
    const startValue = target.scrollTop

    const frameFunc = () => {
      const progress = (Date.now() - beginTime) / 500
      if (progress < 1) {
        target.scrollTop = (1 - progress) * startValue + endValue * progress
        rAF(frameFunc)
      } else {
        target.scrollTop = endValue
        if (callback) {
          callback()
        }
      }
    }

    frameFunc()
  }

  // 获取元素到文档顶部的距离
  const getOffsetSize = (
    Node: HTMLElement,
    offset: { x: any; y: any } = { x: 0, y: 0 },
  ) => {
    if (!offset) {
      offset = {
        x: 0,
        y: 0,
      }
    }
    if (Node === document.body) return offset
    offset.x += Node.offsetLeft
    offset.y += Node.offsetTop
    return getOffsetSize(Node.offsetParent as HTMLElement, offset)
  }

  const toMembershipListByType = (type: any[] = []) => {
    navigateTo({
      name: 'companyListBase',
      query: { membership: type.join(',') },
    })
  }

  return {
    getCurrent,
    MEMBERSHIP_LIST,
    scrollToBottom,
    getOffsetSize,
    toMembershipListByType,
  }
}
